module.exports = __webpack_public_path__ + "img/Exchange.2e64b623.svg";